module.exports = __webpack_public_path__ + "static/img/i6.a5a55db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i6.png
// module id = ItnO
// module chunks = 0